import styled from 'styled-components';

import { fromLarge, fromMedium } from 'styleUtils/mediaQueries';
import { gridColumn, gridRow } from 'styleUtils/grid';

export const ImageWrapper = styled.div`
    width: 100%;
    margin-bottom: 1.5rem;

    ${fromMedium`
        margin-bottom: 3rem;
    `}

    ${fromLarge`
        ${gridColumn({ start: 2 })}
        ${gridRow({ start: 1 })}
        align-content: center;
    `}

    img {
        width: 100%;
    }
`;
